import Typography from '../../../../components/Typography';
import styles from './WelcomeSlide.module.scss';

function WelcomeSlide() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Typography textType="h3" as="h2">
          Welcome to Inform!
        </Typography>
        <Typography textType="h4" as="p">
          Inform will help automate quick replies to your reviews.
        </Typography>
      </div>
      <div>
        <Typography textType="h4" as="p">
          Begin by customizing your AI voice in the 'AI Responses' page.
        </Typography>
        <Typography className={styles.text} textType="p1" as="p">
          Inform also offers templated responses. You can write a custom rule
          and response on the 'Templated Responses' page. If you choose to
          create any, these take dominance over AI-generated responses when a
          matching rule is found.
        </Typography>
      </div>
      <img
        src={require('../../../../assets/robo-reply.png')}
        alt="Robot writting review"
        className={styles.image}
        width="200"
      />
    </div>
  );
}

export default WelcomeSlide;
